import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from '../Icon'

export const BookIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99826 2.99609V16.0015"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0031 16.002V20.0036"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0028 2.99609C19.5553 2.99609 20.0032 3.444 20.0032 3.99651V15.0011C20.0032 15.5536 19.5553 16.0015 19.0028 16.0015H5.99742C4.89239 16.0015 3.99658 16.8973 3.99658 18.0023V18.0023C3.99658 19.1074 4.89239 20.0032 5.99742 20.0032"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99756 20.0031H12.0001"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.002 20.0031H20.0036"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18.5029H16.0017V22.5046L14.0008 21.5042L12 22.5046V18.5029Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.99658 18.0023V4.99693C3.99658 3.8919 4.89239 2.99609 5.99742 2.99609H19.0028"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  </>
)
